// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"0220c454","56":"38b2df9f"}[chunkId] + ".chunk.css";
};